module.exports = __webpack_public_path__ + "assets/img/exploreButton.49b10d27.png";